import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { api } from '../../service/api';
import { Dimmer, Loader, Button } from 'semantic-ui-react';

import Multiselect from 'multiselect-react-dropdown';

import useClientProperties from '../../hooks/useClientProperties';

import { Client } from '../../types';

type ClientPropertiesProps = {
  clientId: string;
  client: Client;
};

type ClientManagedProperties = {
  value: string;
  text: string;
};

const ClientProperties = (props: ClientPropertiesProps) => {
  const { clientId, client } = props;
  const { properties, isLoading } = useClientProperties(clientId);

  const [managedProperties, setManagedProperties] = useState<
    ClientManagedProperties[] | null
  >(null);

  const [editProperties, setEditProperties] = useState(false);

  const updateClient = () => {
    const updatedClient = Object.assign({}, client);
    updatedClient.ManagedProperties = [
      ...managedProperties.map((el) => el.value),
    ];
    api.updateClient({ data: updatedClient }).then((_) => {
      setEditProperties(false);
    });
  };

  useEffect(() => {
    if (!isLoading) {
      if (client.ManagedProperties) {
        setManagedProperties(
          properties.filter((property) =>
            client.ManagedProperties.includes(String(property.value))
          )
        );
      }
    }
  }, [isLoading, client, properties]);

  return (
    <div>
      {isLoading ? (
        <Dimmer active>
          <Loader />
        </Dimmer>
      ) : editProperties && !isLoading ? (
        <div>
          {' '}
          <Multiselect
            options={properties}
            selectedValues={managedProperties}
            displayValue="text"
            onSelect={(
              list: ClientManagedProperties[],
              el: ClientManagedProperties
            ) => {
              setManagedProperties((managedProps) => {
                if (!managedProps) {
                  managedProps = [];
                }
                managedProps.push(el);
                return managedProps;
              });
            }}
            onRemove={(
              list: ClientManagedProperties[],
              el: ClientManagedProperties
            ) => {
              setManagedProperties([
                ...list.filter((x) => x.value !== el.value),
              ]);
            }}
          />
          <Button onClick={updateClient}>Update Managed Properties</Button>
        </div>
      ) : (
        <div>
          {' '}
          <ul style={{ overflow: 'auto', maxHeight: 300 }}>
            {managedProperties &&
              managedProperties.map((el) => {
                return <li key={el.value}>{el.text}</li>;
              })}
          </ul>{' '}
          <Button onClick={() => setEditProperties(true)}>
            Manage Properties
          </Button>
        </div>
      )}
    </div>
  );
};

ClientProperties.propTypes = {
  clientId: PropTypes.string.isRequired,
};

export default ClientProperties;
